interface IHotelFacilityTypes {
  hotel: string;
  activities: string;
  camping: string;
}

export const HotelFacilityTypes: IHotelFacilityTypes = {
  hotel: "hotel",
  activities: "activities",
  camping: "camping",
};
